<template>
    <div id="registraCalibragem">
        <div class="container mb-3">
            <div class="col-12 d-flex justify-content-center">
                <p>{{ $t('Calibragem NR Fogo') }}:
                    <span class="badge badge-warning" style="font-size:16px">{{
                        pneu
                    }}</span>
                </p>
            </div>
            <div class="col-12 d-flex justify-content-center">
                <input class="form-control w-50" type="number" v-model="valorCalibragem">
            </div>
        </div>

        <!-- <template #modal-footer> -->
        <div class="w-100">
            <div class="row center mb-3" style="justify-content: center;">
                <!-- <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                    {{ $t('Cancelar') }}
                </b-button> -->
                <b-button size="lg" variant="success" @click="registraCalibragem">
                    {{ $t('Confirmar') }}
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "ModalExterna",
    props: {
        afericoesFeitas: {},
        pneu: {}
    },

    data() {
        return {
            arrayCalibragem: [],
            registraAfericao: true,
            afericoesFeitasTemp: [],
            photo: null,
            mediaStream: null,
            valorCalibragem: ''
        };
    },
    methods: {
        registraCalibragem() {
            let pneus = this.$store.getters['borracharia/getAfericao']

            // if (this.arrayCalibragem.length < this.afericoesFeitasTemp.length) {
            //     this.$swal.fire({
            //         title: 'Oops!',
            //         text: 'Informe a leitura de todos os sulcos',
            //         icon: 'warning'
            //     })

            //     return false
            // }

            let ds_lado = ''
            let nr_posicao = ''
            let nr_vida = ''

            pneus.forEach(item => {
                if (item.nr_fogo.replace(/\s+/g, '') == this.pneu.replace(/\s+/g, '')) {
                    ds_lado = item.ds_lado
                    nr_posicao = item.nr_posicao
                    nr_vida = item.nr_vida
                }
            })

            const dataCalibragem = {
                nr_fogo: this.pneu,
                ds_lado: ds_lado,
                nr_posicao: nr_posicao,
                calibragem: this.valorCalibragem,
                imagem: this.photo,
                nr_vida: nr_vida
            }

            // console.log(dataCalibragem)

            this.$emit('adicionarCalibragem', dataCalibragem)
        },

        inputCalibragem(event) {
            let data = {
                calibragem: event.target.value
            }

            var indice = this.arrayCalibragem.findIndex(function (item) {
                return item.index === data.index;
            });

            if (indice !== -1) {
                this.arrayCalibragem[indice] = data;
            } else {
                this.arrayCalibragem.push(data);
            }
        },

        populaArray() {
            this.afericoesFeitasTemp = JSON.parse(JSON.stringify(this.afericoesFeitas));
            const aferTemp = JSON.parse(localStorage.afericao)

            const self = this

            aferTemp.afericoes.forEach(afericaoTemp => {

                if (afericaoTemp.nr_fogo == self.pneu) {
                    afericaoTemp.afericoes.forEach(function (afer, index) {
                        self.afericoesFeitasTemp[index].valueTemp = afer.novaAfericao
                    })
                }
            })
        }
    },

}
</script>
